export default {
  getFiltersDateRange: (state = {}) => {
    const filters = state.filters || {}
    const dateRange = filters.dateRange || {}

    return {
      start: dateRange.start || null,
      end: dateRange.end || null,
    }
  },
}
